import { getMcAppFromBaseProps } from "../lib/baseProps";
import {
  IBaseProps,
  IMcAppType,
  NavFlow,
  Tab,
  CommonParameters,
} from "../mcApp.types";

const baseProps = {
  path: "/my-account/self-meter-read",
  navFlow: NavFlow.FOCUS,
  parent: Tab.MORE,
};

const createSelfMeterReadMcApp = ({
  name,
  ...props
}: IBaseProps): IMcAppType[] => {
  name = `selfMeterRead${name}`;
  return [
    getMcAppFromBaseProps({
      ...props,
      name: `${name}_SAP`,
      intent: name,
    }),
    getMcAppFromBaseProps({
      ...props,
      name: `${name}_MAGICLINK`,
      magiclinkPath: "/task/smr",
      intent: name,
    }),
  ];
};

const selfMeterReadApps: IBaseProps[] = [
  {
    name: "",
    subPath: "",
    description: "Self Meter Read landing page",
    title: "Self meter read",
    ...baseProps,
  },
  {
    name: "EnterRead",
    subPath: "accounts/:caid/enter-reading",
    parameters: {
      required: ["caid"],
      properties: { caid: CommonParameters.caid },
    },
    description: "Self Meter Read Enter read page",
    title: "Enter reading",
    ...baseProps,
  },
];

export const selfMeterRead: IMcAppType[] = selfMeterReadApps.flatMap((app) =>
  createSelfMeterReadMcApp(app)
);
